/**
 * @generated SignedSource<<8ab3e901b31114534b4dd8d3ad8097f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAdminAccountsMissingEmployee_storeUser$data = {
  readonly employeeSuggestion: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "UserAdminAccountsMissingEmployee_storeUser";
};
export type UserAdminAccountsMissingEmployee_storeUser$key = {
  readonly " $data"?: UserAdminAccountsMissingEmployee_storeUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAdminAccountsMissingEmployee_storeUser">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAdminAccountsMissingEmployee_storeUser",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employeeSuggestion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        },
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "StoreUser",
  "abstractKey": null
};
})();

(node as any).hash = "d7b7e2b62df689a9ef43ebab19afb5a7";

export default node;
